import store from 'state/store';
import { resolveProductDependencies } from './actions';

export default {
    resolveProductDependencies: page => {
        return store.dispatch(resolveProductDependencies(page));
    },
};
